__turbopack_context__.v({
  "icon": "titleWithIcon-module-scss-module__I0bT1a__icon",
  "iconTooltip": "titleWithIcon-module-scss-module__I0bT1a__iconTooltip",
  "titleContainer": "titleWithIcon-module-scss-module__I0bT1a__titleContainer",
});
